export default __webpack_public_path__ + "static/media/41_desktop.8fdb40c1.jpg";